'use strict'

// ////////////////////////////////////////////////////////////////
//   相关热力图定义
// ///////////////////////////////////////////////////////////////
import {
    _fillRect,
    _drawRect,
    _setLineWidth,
    _getTxtWidth,
    _drawTxt,
    _drawHline,
    _drawVline,
    _drawBegin,
    _drawEnd,
    _drawLineAlone,
} from './cl.draw'
import {
    CHART_LAYOUT,
} from '../cl.chart.res'
import {
    copyJsonOfDeep,
    updateJsonOfDeep,
    offsetRect,
    getGradientColors,
} from '../cl.utils'
import {
    initCommonInfo,
    checkLayout
} from './cl.chart.init'

import ClDrawInfo from './cl.draw.info'

export default class ClChartMHeat {
    /**
  
     * Creates an instance of ClChartLine.
     * @param {Object} father line chart's parent context
     */
    constructor(father) {
        initCommonInfo(this, father)
        this.dataLayer = father.dataLayer
    }
    init(cfg, callback) {
        this.callback = callback
        this.rectMain = cfg.rectMain || {
            left: 0,
            top: 0,
            width: 200,
            height: 300
        }
        this.layout = updateJsonOfDeep(cfg.layout, CHART_LAYOUT)
        this.config = copyJsonOfDeep(cfg.config)

        this.cellnames = cfg.cellnames // ['','']
        this.cellinfos = cfg.cellinfos // [[]]
        // console.log(this.cellnames, this.cellinfos);

        this.cellindex = { lindex : 0, rindex : 0, unitX : this.scale, unitY : this.scale, }

        this.selectIndex = 0
        // this.cellcolor = {
        //     upcolors : getGradientColors("#7f7f7f", "#ff6c6c", 10),
        //     dncolors : getGradientColors("#7f7f7f", "#6cff6c", 10),
        // }
        this.cellcolor = {
            upcolors : ["#1f1f1f", "#2f2f2f", "#3f3f3f", "#4f4f4f", "#af8f8f", "#af6f6f", "#cf7f7f", "#cf5f5f", "#ff6f6f", "#ff4f4f"],
            dncolors : ["#1f1f1f", "#2f2f2f", "#3f3f3f", "#4f4f4f", "#8faf8f", "#6faf6f", "#7fcf7f", "#5fcf5f", "#6fff6f", "#4fff4f"],
        }
        console.log(this.cellcolor);
        // 下面对配置做一定的校验
        this.checkConfig()
        // 再做一些初始化运算，下面的运算范围是初始化设置后基本不变的数据
        this.setPublicRect()
        // 初始化标题信息
        this.initTitle()
    }
    checkConfig() { // 检查配置有冲突的修正过来
        checkLayout(this.layout)
    }
    
    setPublicRect() {
        this.rectChart = offsetRect(this.rectMain, this.layout.margin)
        this.rectChart = offsetRect(this.rectChart, this.layout.offset)
    
        // 计算title和mess矩形位置
        this.rectTitle = {
            left: this.rectMain.left,
            top: this.rectMain.top,
            width: 0,
            height: 0
        }
        this.rectMess = {
            left: this.rectMain.left,
            top: this.rectMain.top,
            width: 0,
            height: 0
        }
        if (this.config.title.display !== 'none') {
            let titleWidth = 0
            if (this.config.title.label !== undefined) {
                titleWidth = _getTxtWidth(this.context, this.config.title.label, 
                    this.layout.title.font, this.layout.title.pixel) + 2 * this.scale
                this.rectTitle = {
                    left: this.rectChart.left,
                    top: this.rectChart.top,
                    width: titleWidth,
                    height: this.layout.title.height
                }
            }
            this.rectMess = {
                left: this.rectChart.left + titleWidth + this.scale,
                top: this.rectChart.top,
                width: this.rectChart.width - titleWidth - this.scale,
                height: this.layout.title.height
            }
            this.rectChart = {
                left: this.rectChart.left,
                top: this.rectChart.top + this.rectMess.height,
                width: this.rectChart.width,
                height: this.rectChart.height - this.rectMess.height
            }
        }
        // console.log(this.cellnames);
        this.cellindex.unitX = this.rectChart.width / this.cellnames.length
        this.cellindex.unitY = this.rectChart.height / this.cellnames.length
    }
    setSelectIndex(index) {
        this.selectIndex = index
    }
    initTitle() {
        if (this.config.title.display === 'none') return
        this.Title = new ClDrawInfo(this, this.rectTitle, this.rectMess)
    }
    drawTitleInfo() {
        if (this.config.title.display === 'none') return
        if (this.cellindex.lindex < 0 || this.cellindex.lindex > this.cellnames.length - 1) this.cellindex.lindex = 0
        if (this.cellindex.rindex < 0 || this.cellindex.rindex > this.cellnames.length - 1) this.cellindex.rindex = 0
        this.Title.onPaint(this.getMoveData(this.cellindex.lindex, this.cellindex.rindex))
    }
    onClick(event) {
        const newIndex = this.getMouseIndex(event.mousePos)
        if (newIndex.lindex !== this.selectIndex) {
            this.selectIndex = newIndex.lindex
            console.log(newIndex, this.selectIndex);
            this.callback({
                event: 'btndown',
                selectIndex: this.selectIndex,
            })
            this.onPaint()
        }
    }
    getMoveData(lindex, rindex) {
        const out = []
        out.push({
            index: 0,
            color: '#5bbccf',
            label: lindex + ' :',
            value: this.cellnames[lindex],
        })
        out.push({
            index: 0,
            color: this.color.yellow,
            label: rindex + ' :',
            value: this.cellnames[rindex],
        })
        let value = this.cellinfos[lindex][rindex]
        let color = this.color.white
        if (value > 0.01) {
            color = this.color.red
        } 
        else if (value < -0.01) {
            color = this.color.green
        }
        out.push({
            index: 0,
            color: color, 
            label: 'correl:',
            value: value,
        })
        return out
    }
    getMouseIndex(mousePos) {
        if (mousePos.y <= this.rectChart.top) {
            return this.cellindex
        } else {
            let rindex = Math.floor((mousePos.y - this.rectChart.top) / this.cellindex.unitY - 0.5)
            // console.log(rindex, mousePos.y - this.rectChart.top);
            if (rindex > this.cellnames.length - 1) {
                rindex = this.cellnames.length - 1
            }
            let lindex = Math.floor((mousePos.x - this.rectChart.left) / this.cellindex.unitX - 0.5)
            if (lindex > this.cellnames.length - 1) {
                lindex = this.cellnames.length - 1
            }
            return {lindex, rindex}
        }
    }
    
    onMouseMove(event) {
        // 找到对应的数据索引
        const newIndex = this.getMouseIndex(event.mousePos)
        // console.log(newIndex);
        if (newIndex.lindex !== this.cellindex.lindex || newIndex.rindex !== this.cellindex.rindex) {
            this.cellindex.lindex = newIndex.lindex
            this.cellindex.rindex = newIndex.rindex
            this.drawTitleInfo(this.cellindex)
        }
    }
    drawClear() {
        _fillRect(this.context, this.rectMain.left, this.rectMain.top, this.rectMain.width, this.rectMain.height, this.color.back)
        _drawBegin(this.context, this.color.grid)
        _drawRect(this.context, this.rectMain.left, this.rectMain.top, this.rectMain.width, this.rectMain.height)
        _drawEnd(this.context)
    }
    getColor(x, y) {
        if (x === y) {
           return  this.color.back
        }
        const value = this.cellinfos[x][y]
        if (value > 0.0) {
            let index = Math.min(Math.round(Math.abs(value) * 10.0), 9)
            return this.cellcolor.upcolors[index]
        }
        else {
            let index = Math.min(Math.round(Math.abs(value) * 10.0), 9)
            return this.cellcolor.dncolors[index]
        }
    }
    drawColor() {
        let moveX = this.rectMess.left + this.rectMess.width / 2;
        let moveW = 10
        for (let index = 0; index < 10; index++) {
            // _drawBegin(this.context, this.cellcolor.upcolors[index]);
            _fillRect(this.context, 
                moveX, 
                this.rectMess.top, 
                moveW, 
                this.rectMess.height,
                this.cellcolor.upcolors[index])
            // _drawEnd(this.context);
            moveX += moveW + this.scale
        }
        moveX += moveW * 2
        for (let index = 0; index < 10; index++) {
            // _drawBegin(this.context, this.cellcolor.dncolors[index]);
            _fillRect(this.context, 
                moveX, 
                this.rectMess.top, 
                moveW, 
                this.rectMess.height,
                this.cellcolor.dncolors[index])
            // _drawEnd(this.context);
            moveX += moveW + this.scale
        }
    }
    drawCell() {
        let moveX = this.rectChart.left + this.scale;
        let moveY = 0
        console.log(this.cellindex);
        for (let x = 0; x < this.cellnames.length; x++) {
            moveY = this.rectChart.top + this.scale;
            for (let y = 0; y < this.cellnames.length; y++) {
                const color = this.getColor(x, y);
                // _drawBegin(this.context, color);
                _fillRect(this.context, 
                    moveX, 
                    moveY, 
                    this.cellindex.unitX - this.scale, 
                    this.cellindex.unitY - this.scale,
                    color)
                // _drawEnd(this.context);
                moveY += this.cellindex.unitY
            }
            moveX += this.cellindex.unitX
            // console.log(x, moveX, moveY);
        }
        _drawBegin(this.context, this.color.cursor)
        moveX = this.rectChart.left + this.selectIndex * this.cellindex.unitX
        moveY = this.rectChart.top + this.selectIndex * this.cellindex.unitY
        _drawRect(this.context, moveX, this.rectChart.top, this.cellindex.unitX, this.rectChart.height)
        _drawRect(this.context, this.rectChart.left, moveY, this.rectChart.width, this.cellindex.unitY)
        _drawEnd(this.context)
        
    }
    
    onPaint() {
        _setLineWidth(this.context, this.scale)
        this.drawClear() // 清理画图区
        this.drawTitleInfo() // 画标题  
        // this.drawColor();
        this.drawCell()     // 画表格  
    }
    
}